import script from "./GameActManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GameActManager.vue?vue&type=script&setup=true&lang=js"

import "./GameActManager.vue?vue&type=style&index=0&id=1ddae58e&lang=less"
import "./GameActManager.vue?vue&type=style&index=1&id=1ddae58e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ddae58e"]])

export default __exports__